import { Delete } from 'lucide-react';

export function Keypad({ value, onChange }) {
  const handlePress = (key) => {
    if (key === 'backspace') {
      onChange(value.slice(0, -1));
    } else if (key === '.') {
      if (!value.includes('.')) {
        onChange(value === '' ? '0.' : value + '.');
      }
    } else {
      const parts = value.split('.');
      if (parts[1] && parts[1].length >= 2) return;
      if (value === '0' && key !== '.') {
        onChange(key);
      } else {
        onChange(value + key);
      }
    }
  };

  const keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '.', '0', 'backspace'];

  return (
    <div className="grid grid-cols-3 gap-px bg-slate-200" data-testid="keypad">
      {keys.map((key) => (
        <button
          key={key}
          onClick={() => handlePress(key)}
          className="keypad-btn"
          data-testid={`keypad-btn-${key === 'backspace' ? 'del' : key}`}
          type="button"
        >
          {key === 'backspace' ? (
            <Delete className="w-6 h-6 text-slate-500" />
          ) : key === '.' ? (
            <span className="text-3xl leading-none">,</span>
          ) : (
            key
          )}
        </button>
      ))}
    </div>
  );
}
